// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_98-0";
export var optionCard = "_98-1";